import React, { createContext, useState } from 'react';

const ModalContext = createContext({});

export default ModalContext;

export const ModalContextProvider = ({ children }) => {
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const openWalletModal = () => setIsWalletModalOpen(true);
  const closeWalletModal = () => setIsWalletModalOpen(false);

  const [isAccessAccountModalOpen, setIsAccessAccountModalOpen] = useState(false);
  const openAccessAccountModal = () => setIsAccessAccountModalOpen(true);
  const closeAccessAccountModal = () => setIsAccessAccountModalOpen(false);

  const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] = useState(false);
  const openCreateAccountModal = () => setIsCreateAccountModalOpen(true);
  const closeCreateAccountModal = () => setIsCreateAccountModalOpen(false);

  // const [isAccountSetUpModalOpen, setIsAccountSetUpModalOpen] = useState(false);
  // const openAccountSetUpModal = () => setIsAccountSetUpModalOpen(true);
  // const closeAccountSetUpModal = () => setIsAccountSetUpModalOpen(false);

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const openPasswordModal = () => setIsPasswordModalOpen(true);
  const closePasswordModal = () => setIsPasswordModalOpen(false);

  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  const openChangePasswordModal = () => setIsChangePasswordModalOpen(true);
  const closeChangePasswordModal = () => setIsChangePasswordModalOpen(false);


  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);
  const openSwapModal = () => setIsSwapModalOpen(true);
  const closeSwapModal = () => setIsSwapModalOpen(false);

  const [isConfirmLogoutModalOpen, setIsConfirmLogoutModalOpen] = useState(false);
  const openConfirmLogoutModal = () => setIsConfirmLogoutModalOpen(true);
  const closeConfirmLogoutModal = () => setIsConfirmLogoutModalOpen(false);

  const [isSeedPhraseModalOpen, setIsSeedPhraseModalOpen] = useState(false);
  const openSeedPhraseModal = () => setIsSeedPhraseModalOpen(true);
  const closeSeedPhraseModal = () => setIsSeedPhraseModalOpen(false);

  const [isIncreasedLimitsModalOpen, setIsIncreasedLimitsModalOpen] = useState(false);
  const openIncreasedLimitsModal = () => setIsIncreasedLimitsModalOpen(true);
  const closeIncreasedLimitsModal = () => setIsIncreasedLimitsModalOpen(false);

  const [isRedeemGiftCardModalOpen, setIsRedeemGiftCardModalOpen] = useState(false);
  const openRedeemGiftCardModal = () => setIsRedeemGiftCardModalOpen(true);
  const closeRedeemGiftCardModal = () => setIsRedeemGiftCardModalOpen(false);

  const [isDisablePasswordModalOpen, setIsDisablePasswordModalOpen] = useState(false);
  const openDisablePasswordModal = () => setIsDisablePasswordModalOpen(true);
  const closeDisablePasswordModal = () => setIsDisablePasswordModalOpen(false);

  const [isNetworkDropdownOpen, setIsNetworkDropdownOpen] = useState(false);
  const openNetworkDropdown = () => setIsNetworkDropdownOpen(true);
  const closeNetworkDropdown = () => setIsNetworkDropdownOpen(false);

  const [isWalletDropdownOpen, setIsWalletDropdownOpen] = useState(false);
  const openWalletDropdown = () => setIsWalletDropdownOpen(true);
  const closeWalletDropdown = () => setIsWalletDropdownOpen(false);

  const [isZkAccountDropdownOpen, setIsZkAccountDropdownOpen] = useState(false);
  const openZkAccountDropdown = () => setIsZkAccountDropdownOpen(true);
  const closeZkAccountDropdown = () => setIsZkAccountDropdownOpen(false);

  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  const openMoreDropdown = () => setIsMoreDropdownOpen(true);
  const closeMoreDropdown = () => setIsMoreDropdownOpen(false);

  const [isTokenSelectorOpen, setIsTokenSelectorOpen] = useState(false);
  const openTokenSelector = () => setIsTokenSelectorOpen(true);
  const closeTokenSelector = () => setIsTokenSelectorOpen(false);

  const [isTokenListModalOpen, setIsTokenListModalOpen] = useState(false);
  const openTokenListModal = () => setIsTokenListModalOpen(true);
  const closeTokenListModal = () => setIsTokenListModalOpen(false);

  const [isPaymentLinkModalOpen, setIsPaymentLinkModalOpen] = useState(false);
  const openPaymentLinkModal = () => setIsPaymentLinkModalOpen(true);
  const closePaymentLinkModal = () => setIsPaymentLinkModalOpen(false);

  const [isPaymentConfirmationModalOpen, setIsPaymentConfirmationModalOpen] = useState(false);
  const openPaymentConfirmationModal = () => setIsPaymentConfirmationModalOpen(true);
  const closePaymentConfirmationModal = () => setIsPaymentConfirmationModalOpen(false);

  const [isWrapModalOpen, setIsWrapModalOpen] = useState(false);
  const [wrapModalMode, setWrapModalMode] = useState('wrap');
  const openWrapModal = mode => {
    setWrapModalMode(mode || 'wrap');
    setIsWrapModalOpen(true);
  };
  const closeWrapModal = () => setIsWrapModalOpen(false);

  const closeAllModals = () => {
    closeWalletModal();
    // closeAccountSetUpModal();
    closeAccessAccountModal();
    closeCreateAccountModal();
    closeChangePasswordModal();
    closeSwapModal();
    closeConfirmLogoutModal();
    closeSeedPhraseModal();
    closeIncreasedLimitsModal();
    closeNetworkDropdown();
    closeWalletDropdown();
    closeZkAccountDropdown();
    closeMoreDropdown();
    closeTokenSelector();
    closePaymentLinkModal();
    closePaymentConfirmationModal();
    closeWrapModal();
  };

  return (
    <ModalContext.Provider
      value={{
        isWalletModalOpen, openWalletModal, closeWalletModal,
        // isAccountSetUpModalOpen, openAccountSetUpModal, closeAccountSetUpModal,
        // accountSetUpModalMode, openAccessAccountModal, openCreateAccountModal,
        isAccessAccountModalOpen, openAccessAccountModal, closeAccessAccountModal,
        isCreateAccountModalOpen, openCreateAccountModal, closeCreateAccountModal,
        isPasswordModalOpen, openPasswordModal, closePasswordModal,
        isChangePasswordModalOpen, openChangePasswordModal, closeChangePasswordModal,
        isSwapModalOpen, openSwapModal, closeSwapModal,
        isConfirmLogoutModalOpen, openConfirmLogoutModal, closeConfirmLogoutModal,
        isSeedPhraseModalOpen, openSeedPhraseModal, closeSeedPhraseModal,
        isIncreasedLimitsModalOpen, openIncreasedLimitsModal, closeIncreasedLimitsModal,
        isRedeemGiftCardModalOpen, openRedeemGiftCardModal, closeRedeemGiftCardModal,
        isDisablePasswordModalOpen, openDisablePasswordModal, closeDisablePasswordModal,
        isNetworkDropdownOpen, openNetworkDropdown, closeNetworkDropdown,
        isWalletDropdownOpen, openWalletDropdown, closeWalletDropdown,
        isZkAccountDropdownOpen, openZkAccountDropdown, closeZkAccountDropdown,
        isMoreDropdownOpen, openMoreDropdown, closeMoreDropdown,
        isTokenSelectorOpen, openTokenSelector, closeTokenSelector,
        isTokenListModalOpen, openTokenListModal, closeTokenListModal,
        isPaymentLinkModalOpen, openPaymentLinkModal, closePaymentLinkModal,
        isPaymentConfirmationModalOpen, openPaymentConfirmationModal, closePaymentConfirmationModal,
        isWrapModalOpen, openWrapModal, closeWrapModal, wrapModalMode,
        closeAllModals,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
